import { render, staticRenderFns } from "./AgileCustom.vue?vue&type=template&id=01c89054&"
import script from "./AgileCustom.vue?vue&type=script&lang=js&"
export * from "./AgileCustom.vue?vue&type=script&lang=js&"
import style0 from "./AgileCustom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports